
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import { format } from 'date-fns';
import "react-datepicker/dist/react-datepicker.css";
import './AddDocument.css';
import axios from 'axios';
import { useSelector } from 'react-redux';

const API_BASE_URL = process.env.REACT_APP_EZTS_API_BASE_URL;

const AddDocument = () => {
  const { token, user } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    dept_id: '',
    doc_date: null,
    description: '',
    file: null,
  });
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const departments = [
    { id: '1', name: 'Finance' },
    { id: '4', name: 'HR' },
    { id: '5', name: 'IT' },
  ];

  const validateForm = () => {
    const newErrors = {};
    if (!formData.dept_id) newErrors.dept_id = 'Department is required';
    if (!formData.doc_date) newErrors.doc_date = 'Document date is required';
    //if (!formData.description) newErrors.description = 'Description is required'; 
    if (formData.description.length > 512) newErrors.description = 'Description must be 512 characters or less';
    if (!formData.file) newErrors.file = 'File is required';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'file') {
      setFormData(prev => ({ ...prev, file: files[0] }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleDateChange = (date) => {
    setFormData(prev => ({ ...prev, doc_date: date }));
    if (errors.doc_date) {
      setErrors(prev => ({ ...prev, doc_date: '' }));
    }
  };

  // Submit - using POST only
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsSubmitting(true);
      setErrors({});

      // Calls on validation
      if (!validateForm()) {
        setIsSubmitting(false);
        return;
      }

      // Build multipart/form-data request body
      const formPayload = new FormData();

      formPayload.append('file', formData.file);
      formPayload.append('departmentId', formData.dept_id); // Get proper departmentIds
      formPayload.append('date', formData.doc_date.toISOString().split("T")[0]);
      formPayload.append('description', formData.description || '');
      formPayload.append('assignedUids', user.userId);
      formPayload.append('assignedTypeids', '');

      // Displays payload
      for (let pair of formPayload.entries()) {
        console.log(pair[0], pair[1]);
      }

      // Always use POST for both new and existing timesheets
      await axios.post(
        `${API_BASE_URL}document/upload`,
        formPayload,
        { 
          headers: { Authorization: `Bearer ${token}` },
          "Content-Type": "multipart/form-data"
        }
      );

      setIsSubmitted(true);
      // Navigate back to document
      navigate('/documents');
    } catch (err) {
      console.error('Submit error:', err);
      console.error('Error response:', err.response?.data);
      setErrors(err.message || 'Error submitting document');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="add-document-container">
      <div className="add-document-card">
        <div className="add-document-title">Add New Document</div>
        <form onSubmit={handleSubmit}>
          <div className="form-section">
            <div className="form-group">
              <label htmlFor="dept_id">Department</label>
              <select
                name="dept_id"
                value={formData.dept_id}
                onChange={handleChange}
                className={errors.dept_id ? 'error' : ''}
              >
                <option value="">Select department</option>
                {departments.map(dept => (
                  <option key={dept.id} value={dept.id}>{dept.name}</option>
                ))}
              </select>
              {errors.dept_id && <div className="error-message">{errors.dept_id}</div>}
            </div>
            <div className="form-group">
              <label htmlFor="doc_date">Date</label>
              <DatePicker
                selected={formData.doc_date}
                onChange={handleDateChange}
                className={`date-input${errors.doc_date ? ' error' : ''}`}
                dateFormat="yyyy-MM-dd"
                placeholderText="Select date"
              />
              {errors.doc_date && <div className="error-message">{errors.doc_date}</div>}
            </div>
            <div className="form-group">
              <label htmlFor="description">Description</label>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleChange}
                maxLength={512}
                rows={4}
                className={errors.description ? 'error' : ''}
                placeholder="Enter description (max 512 characters)"
              />
              <div style={{ fontSize: '0.9rem', color: '#888', marginTop: '2px' }}>{formData.description.length}/512</div>
              {errors.description && <div className="error-message">{errors.description}</div>}
            </div>
            <div className="form-group">
              <label htmlFor="file">Upload File</label>
              <input
                id="file"
                type="file"
                name="file"
                onChange={handleChange}
                className={errors.file ? 'error' : ''}
                accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
              />
              {errors.file && <div className="error-message">{errors.file}</div>}
            </div>
          </div>
          <div className="form-actions">
            <button type="submit" className="submit-button" disabled={isSubmitting}>Submit</button>
            <button type="button" className="add-document-back-btn" onClick={() => navigate('/documents')}>Back</button>
          </div>
          {isSubmitted && <div className="add-document-success-text">Document added successfully!</div>}
        </form>
      </div>
    </div>
  );
};

export default AddDocument;
